module.exports = __webpack_public_path__ + "static/media/NoStudyImg.55612f53.png";